
import React from 'react';

import Carousel from "@ingka/carousel";
import CarouselItem from '../UI/CarouselItem';
import CardContent from '../UI/CardContent';



const FourthSection = (props) => {

    const displayPopupOnClick = () =>{
        console.log("clickImage in  TabPanelItem:::");
        props.onClick();
    }

    const categoryHasId = (value) =>{
        return  value.toLowerCase().replace(/\s+/g, "-");
    }
    
    return (
        <>
            {(props.item.category4[0] && props.item.category4[0].title) &&
                <h3 id={categoryHasId(props.item.category4[0].title)}> {props.item.category4[0].title} </h3>}

            {(props.item.category4[0] && props.item.category4[0].content) && 
            <Carousel>
                {props.item.category4[0].content.map((carouselItem) => (
                    <CarouselItem
                        className={carouselItem.className}
                        key={carouselItem.id}
                        image={carouselItem.imagePath}
                        NameofDish={carouselItem.NameofDish}
                        title={carouselItem.title}
                        onClick = {displayPopupOnClick}
                    />
                ))}
            </Carousel>}
            

            {(props.item.category4[0] && props.item.category4[0].cardcontent) && props.item.category4[0].cardcontent.map((cardContent) => (
                <CardContent
                    key={cardContent.id}
                    cardImage={cardContent.cardImage}
                    cardTitle={cardContent.cardTitle}
                    cardDescription={cardContent.cardDescription}
                />
            ))}
        </>
    )
}

export default FourthSection;
